import api from "../../../api/apibackend";
import Nprogress from "nprogress";
import Vue from "vue";
import {
	SET_PRODUCTS,
	FETCH_START,
	FETCH_END,
	SET_IMAGE_PRODUCT,
	FETCH_IMAGES_START,
	FETCH_IMAGES_END,
} from "./mutations.type";
import {
	GET_PRODUCTS,
	CREATE_PRODUCT,
	DELETE_PRODUCT,
	UPDATE_PRODUCT,
	ADD_IMAGE_PRODUCT,
	DELETE_IMAGE_PRODUCT,
	GET_IMAGES_PRODUCT,
} from "./actions.type";
import { GET_CATALOGUES } from "../catalogues/actions.type";
import { GET_STORE_USER_AUTH } from "../storeModule/actions.type";

const state = {
	products: [],
	images: [],
	loadingProduct: false,
	loadingImages: false,
};

const getters = {
	products: (state) => state.products,
	loadingProduct: (state) => state.loadingProduct,
	imagesProduct: (state) => state.images,
	loadingImages: (state) => state.loadingImages,
};

const mutations = {
	[SET_PRODUCTS](state, products) {
		state.products = products;
	},
	[FETCH_START](state) {
		Nprogress.start();
		state.loadingProduct = true;
	},
	[FETCH_END](state) {
		Nprogress.done();
		state.loadingProduct = false;
	},
	[SET_IMAGE_PRODUCT](state, images) {
		state.images = images;
	},
	[FETCH_IMAGES_START](state) {
		state.loadingImages = true;
	},
	[FETCH_IMAGES_END](state) {
		state.loadingImages = false;
	},
};

const actions = {
	async [GET_PRODUCTS]({ commit, dispatch, rootGetters }) {
		try {
			commit(FETCH_START);
			if (!rootGetters.store) {
				await dispatch(GET_STORE_USER_AUTH);
			}
			await dispatch(GET_CATALOGUES);
			const res = await api.get(`store/${rootGetters.store.id}/products`);
			const products = res.data;

			products.forEach((product) => {
				const catalogueResult = rootGetters.catalogues.find((catalogue) => {
					return catalogue.id === product.catalogue_id;
				});
				product.catalogueName = catalogueResult.name;
			});
			commit(SET_PRODUCTS, products);
			commit(FETCH_END);
		} catch (err) {
			commit(FETCH_END);
			const message = err.response.data.message;
			Vue.notify({
				group: "loggedIn",
				type: "error",
				text: message || err.message,
			});
		}
	},
	async [CREATE_PRODUCT]({ dispatch, commit }, product) {
		try {
			commit(FETCH_START);
			const { data } = await api.post(
				`catalogues/${product.catalogue_id}/products`,
				product
			);

			if (product.image.length) {
				dispatch(ADD_IMAGE_PRODUCT, {
					productId: data.id,
					images: product.image,
				});
			}

			await dispatch(GET_PRODUCTS);

			Vue.notify({
				group: "loggedIn",
				type: "success",
				text: "✔️ Producto agregado exitosamente",
			});
			commit(FETCH_END);
		} catch (err) {
			commit(FETCH_END);
			const message = err.response.data.message;
			Vue.notify({
				group: "loggedIn",
				type: "error",
				text: message || "❌ Ha ocurrido un error al agregar el producto",
			});
		}
	},
	async [DELETE_PRODUCT]({ dispatch, commit }, productId) {
		try {
			commit(FETCH_START);
			const res = await api.delete(`products/${productId}`);
			await dispatch(GET_PRODUCTS);
			commit(FETCH_END);
			Vue.notify({
				group: "loggedIn",
				type: "success",
				text: "✔️ Producto eliminado exitosamente",
			});
		} catch (err) {
			commit(FETCH_END);
			const message = err.response.data.message;
			Vue.notify({
				group: "loggedIn",
				type: "error",
				text: message || "❌ Ha ocurrido un error al eliminar el producto",
			});
		}
	},
	async [UPDATE_PRODUCT]({ dispatch, commit }, product) {
		try {
			commit(FETCH_START);
			const res = await api.patch(`products/${product.id}`, product);
			await dispatch(GET_PRODUCTS);
			commit(FETCH_END);
			Vue.notify({
				group: "loggedIn",
				type: "success",
				text: "✔️ Producto actualizado exitosamente",
			});
		} catch (err) {
			commit(FETCH_END);
			const message = err.response.data.message;
			Vue.notify({
				group: "loggedIn",
				type: "error",
				text: message || "❌ Ha ocurrido un error al modificar el producto",
			});
		}
	},
	async [ADD_IMAGE_PRODUCT]({ commit, dispatch }, { productId, images }) {
		try {
			const formData = new FormData();
			images.forEach((image) => {
				formData.append("images[]", image.file, image.file.name);
			});
			commit(FETCH_START);
			const res = await api.post(`products/${productId}/image`, formData);
			dispatch(GET_IMAGES_PRODUCT, productId);
			commit(FETCH_END);
		} catch (err) {
			commit(FETCH_END);
			const message = err.response.data.message;
			Vue.notify({
				group: "loggedIn",
				type: "error",
				text: message || err.message,
			});
		}
	},
	async [DELETE_IMAGE_PRODUCT]({ commit, dispatch }, { productId, imageId }) {
		try {
			commit(FETCH_START);
			const res = await api.delete(`images/${imageId}`);
			dispatch(GET_IMAGES_PRODUCT, productId);
			commit(FETCH_END);
		} catch (err) {
			commit(FETCH_END);
			const message = err.response.data.message;
			Vue.notify({
				group: "loggedIn",
				type: "error",
				text: message || err.message,
			});
		}
	},
	async [GET_IMAGES_PRODUCT]({ commit }, productId) {
		try {
			commit(FETCH_IMAGES_START);
			commit(SET_IMAGE_PRODUCT, []);
			const res = await api.get(`products/${productId}/image`);
			commit(SET_IMAGE_PRODUCT, res.data);
			commit(FETCH_IMAGES_END);
		} catch (err) {
			commit(FETCH_IMAGES_END);
			const message = err.response.data.message;
			Vue.notify({
				group: "loggedIn",
				type: "error",
				text: message || err.message,
			});
		}
	},
};

export default {
	state,
	getters,
	mutations,
	actions,
};
